import * as React from 'react';
/**
 * React component that only renders its contents if props.showIf is true.
 *
 * This is designed to make a more readable version of {condition? (<SomeComponentsHere>...</SomeCompnentsHere>): null} were its helpful,
 * but is not designed to replace that pattern altogether, in particular, that pattern is always better when an else or condition chaining is to be used.
 *
 * @param props
 */
export var ConditionalFragment = function (props) {
    var showIf = props.showIf, children = props.children;
    if (!showIf) {
        return (React.createElement(React.Fragment, null));
    }
    return (React.createElement(React.Fragment, null, children));
};
//# sourceMappingURL=ConditionalFragment.js.map